<template>
  <div class="batch-card-sort-combo">
    <p
      v-if="showHide"
      :id="'batch-card-sort-combo-container-' + index"
      class="label"
      @click="ShowOffComboSortSamples(index)"
    >
      Lote ordenado por {{ labelSelected }}. <span>Clique</span> para reordenar
    </p>
    <div v-else>
      <md-layout
        md-flex="100"
        md-flex-medium="100"
      >
        <md-input-container>
          <advanced-select
            id="cboSortPrintBatch"
            v-model="batchesUnprintedSortPrint"
            :options="options"
            :placeholder="'Selecione uma opção'"
            :direction="'top'"
            name="sort"
            @onChange="ShowOffComboSortSamples(index)"
          />
        </md-input-container>
      </md-layout>
    </div>
  </div>
</template>

<script>
import mixin from './../../BatchesMixin'

export default {
  name: 'BatchCardSortCombo',
  mixins: [mixin],
  props: {
    labelSelected: {
      type: String
    },
    index: {
      type: Number
    },
    showHide: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-sort-combo {
  display: flex;
  flex-direction: column;
  width: 100%;

  .label {
    margin-top: 8px;
    font-family: 'Exo 2', sans-serif !important;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    align-items: center;
    text-align: center;
    color: #828282;

    span {
      cursor: pointer;
      color: #933e6f;
      text-decoration: underline;
    }
  }
}
</style>
